module.exports = __webpack_public_path__ + "img/bg.df250558.png";